// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== B-book feedback: empty and error states and alert banners ===== */

/* ----- empty and error states ----- */

.b_book_page .b_book_empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--bb-space-2);
    padding: var(--bb-space-6) var(--bb-space-4);
    text-align: center;
    color: var(--bb-soft);
    border: 1px dashed var(--border);
    border-radius: var(--radius-md);
}

.b_book_page .b_book_empty_title {
    margin: 0;
    font-weight: 600;
    color: var(--text-primary);
}

.b_book_page .b_book_empty_hint {
    margin: 0;
    max-width: 60ch;
    font-size: 13px;
}

.b_book_page .b_book_empty_error {
    color: var(--bb-loss);
    background-color: var(--danger-light);
    border-style: solid;
    border-color: color-mix(in srgb, var(--bb-loss) 30%, transparent);
}

.b_book_page .b_book_retry {
    margin-top: var(--bb-space-2);
}

/* ----- alert banners ----- */

.b_book_page .b_book_pnl_alert {
    display: flex;
    align-items: flex-start;
    gap: var(--bb-space-3);
    margin: 0 0 var(--bb-space-3);
    padding: var(--bb-space-3) var(--bb-space-4);
    border-radius: var(--radius-md);
    border: 1px solid;
    border-left-width: 4px;
    font-size: 14px;
    line-height: 1.5;
    color: var(--text-primary);
}

.b_book_page .b_book_pnl_alert .b_book_icon {
    margin-top: 1px;
}

.b_book_page .b_book_pnl_alert_danger {
    border-color: var(--bb-loss);
    background-color: var(--danger-light);
}

.b_book_page .b_book_pnl_alert_danger .b_book_icon {
    color: var(--bb-loss);
}

.b_book_page .b_book_pnl_alert_warning {
    border-color: var(--bb-warn);
    background-color: var(--warning-light);
}

.b_book_page .b_book_pnl_alert_warning .b_book_icon {
    color: var(--bb-warn);
}

.b_book_page .b_book_pnl_alert_muted {
    border-color: var(--border);
    border-left-color: var(--text-secondary);
    background-color: var(--bg);
    color: var(--bb-soft);
}
`, "",{"version":3,"sources":["webpack://./src/pages/bBook/bBookFeedback.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E,uCAAuC;;AAEvC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,mBAAmB;IACnB,iEAAiE;AACrE;;AAEA;IACI,6BAA6B;AACjC;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;IAC7B,4CAA4C;IAC5C,+BAA+B;IAC/B,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC,2BAA2B;IAC3B,qBAAqB;AACzB","sourcesContent":["/* ===== B-book feedback: empty and error states and alert banners ===== */\n\n/* ----- empty and error states ----- */\n\n.b_book_page .b_book_empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: var(--bb-space-2);\n    padding: var(--bb-space-6) var(--bb-space-4);\n    text-align: center;\n    color: var(--bb-soft);\n    border: 1px dashed var(--border);\n    border-radius: var(--radius-md);\n}\n\n.b_book_page .b_book_empty_title {\n    margin: 0;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_empty_hint {\n    margin: 0;\n    max-width: 60ch;\n    font-size: 13px;\n}\n\n.b_book_page .b_book_empty_error {\n    color: var(--bb-loss);\n    background-color: var(--danger-light);\n    border-style: solid;\n    border-color: color-mix(in srgb, var(--bb-loss) 30%, transparent);\n}\n\n.b_book_page .b_book_retry {\n    margin-top: var(--bb-space-2);\n}\n\n/* ----- alert banners ----- */\n\n.b_book_page .b_book_pnl_alert {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--bb-space-3);\n    margin: 0 0 var(--bb-space-3);\n    padding: var(--bb-space-3) var(--bb-space-4);\n    border-radius: var(--radius-md);\n    border: 1px solid;\n    border-left-width: 4px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_pnl_alert .b_book_icon {\n    margin-top: 1px;\n}\n\n.b_book_page .b_book_pnl_alert_danger {\n    border-color: var(--bb-loss);\n    background-color: var(--danger-light);\n}\n\n.b_book_page .b_book_pnl_alert_danger .b_book_icon {\n    color: var(--bb-loss);\n}\n\n.b_book_page .b_book_pnl_alert_warning {\n    border-color: var(--bb-warn);\n    background-color: var(--warning-light);\n}\n\n.b_book_page .b_book_pnl_alert_warning .b_book_icon {\n    color: var(--bb-warn);\n}\n\n.b_book_page .b_book_pnl_alert_muted {\n    border-color: var(--border);\n    border-left-color: var(--text-secondary);\n    background-color: var(--bg);\n    color: var(--bb-soft);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
